<p class="avenir-font d-flex justify-content-start align-items-center">
  <b>Filter By Hit Count</b> 
  <!-- <mat-icon class="text-muted ms-2" ngbPopover="Need text here..."
      triggers="mouseenter:mouseleave">info
    </mat-icon> -->
</p>
<div class="custom-slider ms-3 ps-2 pe-3">
  <ngx-slider [(value)]="sliderValue" [options]="sliderOptions" (valueChange)="onIntensityChange()"></ngx-slider>
</div>
